import React, { useState, useRef, useEffect } from 'react';
import colors from 'src/style/colors';

const countries = [
  { code: 'FR', dialCode: '+33', flag: '🇫🇷', name: 'France' },
  { code: 'BE', dialCode: '+32', flag: '🇧🇪', name: 'Belgique' },
  { code: 'CH', dialCode: '+41', flag: '🇨🇭', name: 'Suisse' },
  { code: 'CA', dialCode: '+1', flag: '🇨🇦', name: 'Canada' },
  { code: 'US', dialCode: '+1', flag: '🇺🇸', name: 'États-Unis' },
  { code: 'GB', dialCode: '+44', flag: '🇬🇧', name: 'Royaume-Uni' },
  { code: 'DE', dialCode: '+49', flag: '🇩🇪', name: 'Allemagne' },
  { code: 'ES', dialCode: '+34', flag: '🇪🇸', name: 'Espagne' },
  { code: 'IT', dialCode: '+39', flag: '🇮🇹', name: 'Italie' },
  { code: 'PT', dialCode: '+351', flag: '🇵🇹', name: 'Portugal' },
  { code: 'MA', dialCode: '+212', flag: '🇲🇦', name: 'Maroc' },
  { code: 'DZ', dialCode: '+213', flag: '🇩🇿', name: 'Algérie' },
  { code: 'TN', dialCode: '+216', flag: '🇹🇳', name: 'Tunisie' },
];

const PhoneInputCustom = ({ value, onChange, onBlur, error, touched }) => {
  const [selectedCountry, setSelectedCountry] = useState(countries[0]);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setIsOpen(false);
    // Update the full phone number
    const fullNumber = phoneNumber ? `${country.dialCode}${phoneNumber}` : '';
    onChange(fullNumber);
  };

  const handlePhoneChange = (e) => {
    const number = e.target.value.replace(/[^\d]/g, '');
    setPhoneNumber(number);
    const fullNumber = number ? `${selectedCountry.dialCode}${number}` : '';
    onChange(fullNumber);
  };

  return (
    <div css={{ display: 'flex', gap: '0.5rem' }}>
      {/* Country Selector Dropdown */}
      <div css={{ position: 'relative', flexShrink: 0 }} ref={dropdownRef}>
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          css={{
            width: '70px',
            height: 42,
            padding: '0 0.5rem',
            border: `2px solid ${error && touched ? colors.red : '#e5e7eb'}`,
            borderRadius: 8,
            backgroundColor: colors.white,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1rem',
            boxSizing: 'content-box',
            transition: 'all 0.3s ease',
            '&:hover': {
              borderColor: colors.purple,
            },
            '&:focus': {
              outline: 'none',
              borderColor: colors.purple,
              boxShadow: `0 0 0 3px rgba(99, 102, 241, 0.1)`,
            },
          }}
        >
          <span css={{ fontSize: '1.25rem' }}>{selectedCountry.flag}</span>
        </button>

        {/* Dropdown Menu */}
        {isOpen && (
          <div
            css={{
              position: 'absolute',
              top: 'calc(100% + 4px)',
              left: 0,
              minWidth: '240px',
              backgroundColor: colors.white,
              border: `2px solid #e5e7eb`,
              borderRadius: 8,
              boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
              zIndex: 1000,
              maxHeight: '250px',
              overflowY: 'auto',
            }}
          >
            {countries.map((country) => (
              <button
                key={country.code}
                type="button"
                onClick={() => handleCountrySelect(country)}
                css={{
                  width: '100%',
                  padding: '0.75rem 1rem',
                  border: 'none',
                  backgroundColor:
                    selectedCountry.code === country.code
                      ? 'rgba(99, 102, 241, 0.1)'
                      : colors.white,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  fontSize: '0.95rem',
                  textAlign: 'left',
                  transition: 'background-color 0.2s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(99, 102, 241, 0.05)',
                  },
                }}
              >
                <span css={{ fontSize: '1.25rem' }}>{country.flag}</span>
                <div css={{ flex: 1 }}>
                  <div css={{ fontWeight: 500, color: colors.black }}>{country.name}</div>
                  <div css={{ fontSize: '0.75rem', color: colors.darkGrey }}>
                    {country.dialCode}
                  </div>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Phone Number Input */}
      <input
        type="tel"
        value={phoneNumber}
        onChange={handlePhoneChange}
        onBlur={onBlur}
        placeholder="6 12 34 56 78"
        css={{
          flex: 1,
          height: 42,
          padding: '0 1rem',
          border: `2px solid ${error && touched ? colors.red : '#e5e7eb'}`,
          borderRadius: 8,
          fontSize: '1rem',
          boxSizing: 'content-box',
          transition: 'all 0.3s ease',
          '&:focus': {
            outline: 'none',
            borderColor: colors.purple,
            boxShadow: `0 0 0 3px rgba(99, 102, 241, 0.1)`,
          },
        }}
      />
    </div>
  );
};

export default PhoneInputCustom;
